import React, { useState, Fragment, useEffect } from 'react';
import {
  Row, Button, FormGroup, Label, Input, Alert, Carousel,
  CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption
} from 'reactstrap';
import Navbarh from '../navbar/Navbar';
import '../estilos.css';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import Moment from 'moment';
import Pagination from "react-js-pagination";
import * as IoIcons from 'react-icons/io';
import useProductos from '../../hooks/useProductos';


function Productos() {
  //Uso descontracturado de las variables y funciones del hook useProductos
  const { pproductos, vpreciounitario, formType, color, aVisible, mensajeAlert,
    cargando, clienteName, mostrarproducto, clienteActivo,
    searchBy, estadoProductos, clientes, estadoCliente,
    search, productos, clienteID, totalRecords, currentPage,
    recordPerPage, pageRange, formData, activeIndex, items,
    slides, imagenn, documenton, isDisabled, formImages,
    editarArchivo, editarProducto, catalogo, onDismiss,
    onSearchBy, nuevoProducto, onEstadoProductos, setSearch,
    onSearch, onClickProducto, fetchProductos, handlePageChange,
    regresarCliente, next, previous, goToIndex, onChanges, onChangescheck,
    onChangeimage, onChangedocumento, setImagenn, setDocumenton,
    onClickCliente, sClienteEstado, createProductos, updateProductos } = useProductos();


  return (
    <>
      <Navbarh />
      {pproductos === true && (
        <>
          <Row>
            <div className="headerp col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <IoIcons.IoMdCog className="iconoc floatleft" onClick={catalogo} />
              <h3 >{formType}</h3>
            </div>
          </Row>
          <div className="conteiner5">
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
              {mensajeAlert}
            </Alert>

            {cargando === true && (
              <Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                  <img width="150px" src="assets/img/preloader.gif" />
                </div>
              </Row>
            )}

            {//Catálogo de Clientes
              formType === 'Catálogo' && (
                <Fragment>
                  <Row>
                    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12 text-left " >
                      <button class="cbutton btn-success margintop20px " onClick={() => nuevoProducto(false)}> <span class="fa fa-plus"> Agregar producto</span> </button>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-left " >
                      <Label>Mostrando clientes</Label>
                      <select name="clienteestado " className="floatleft custom-select" onChange={sClienteEstado}>
                        <option value="todos" >Todos</option>
                        <option value="true">Activos</option>
                        <option value="false">Inactivos</option>
                      </select>
                    </div>
                  </Row>
                  <div>
                  </div>
                  {
                    <Row>
                      {clientes.map(cliente => (
                        <>
                          {estadoCliente === "todos" && (
                            <div key={cliente.id || cliente.cliente} className="col-lg-3 col-md-6 col-sm-12  margintop20px">
                              {
                                <div>
                                  {
                                    cliente.image && <img src={cliente.image} width="100px" onClick={() => onClickCliente(cliente.cliente, cliente.id, cliente.activo)} className="cursorpointer" />
                                  }
                                  <h4>{cliente.cliente} </h4>
                                  <h4>{cliente.activo}</h4>
                                </div>
                              }
                            </div>)
                          }
                          {estadoCliente === cliente.activo.toString() && (
                            <div key={cliente.id || cliente.cliente} className="col-lg-3 col-md-6 col-sm-12  margintop20px">
                              {
                                <div>
                                  {
                                    cliente.image && <img src={cliente.image} width="100px" onClick={() => onClickCliente(cliente.cliente, cliente.id, cliente.activo)} className="cursorpointer" />
                                  }
                                  <h4>{cliente.cliente} </h4>
                                  <h4>{cliente.activo}</h4>
                                </div>
                              }
                            </div>)
                          }
                        </>))
                      }
                    </Row>
                  }
                </Fragment>
              )
            }
            {//Catálogo de Productos
              formType === 'Catálogo - ' + clienteName && (
                <Fragment>
                  {!mostrarproducto && (
                    <>
                      <Row>

                        {clienteActivo && (
                          <div class="col-lg-3 col-md-4 col-sm-12 col-xs-12 text-left " >
                            <button class="cbutton btn-success margintop20px " onClick={nuevoProducto}> <span class="fa fa-plus"> Agregar producto</span> </button>
                          </div>
                        )}
                        {
                          <div class={clienteActivo ? "col-lg-7 col-md-5 col-sm-12 col-xs-12 text-left margintopmobil20px" : "col-lg-10 col-md-9 col-sm-12 col-xs-12 text-left margintopmobil20px"} >
                            <Label><h5>Busqueda por: </h5></Label>
                            <select className="ml-2" onChange={onSearchBy}>
                              <option value="número de parte" selected={searchBy === "número de parte" ? true : false}>Número de parte</option>
                              <option value="descripción" selected={searchBy === "descripción" ? true : false}>Descripción</option>
                            </select>
                            <select className=" estadoproductoscombo" onChange={onEstadoProductos}>
                              <option value="todos" selected={estadoProductos === "todos" ? true : false}>Todos los productos</option>
                              <option value="activos" selected={estadoProductos === "activos" ? true : false}>Productos Activos</option>
                              <option value="inactivos" selected={estadoProductos === "inactivos" ? true : false}>Productos Inactivos</option>
                            </select>
                            <Input
                              type="text"
                              placeholder={"Búsqueda por " + searchBy}
                              onChange={(e) => setSearch(e.target.value)}
                              onKeyUp={onSearch}
                              value={search}
                            />
                          </div>}
                        <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                          <button class="floatrightleft btn-info cbutton margintop20px" onClick={catalogo} title="Regresar"> <IoIcons.IoMdArrowRoundBack />Regresar </button>
                        </div>
                      </Row>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left " >
                        <button className="cbutton btn-dark floatright  " title="Recargar página" onClick={() => { fetchProductos(clienteID, searchBy, search, estadoProductos) }}><IoIcons.IoMdRefresh /> Recargar </button>
                      </div>
                      <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                        <Table className=" mb-2 scroll ">
                          <Thead class="thead-secondary">
                            <Tr>
                              <Th >Número de parte</Th>
                              <Th >Número de parte para embarques</Th>
                              <Th>Descripción</Th>
                              <Th>Cantidad por año</Th>
                              <Th className={vpreciounitario === false ? " displaynone" : "minwidth100px"}>Precio unitario Ecoat</Th>
                              {/*<Th className={vpreciounitario === false ? " displaynone" : "minwidth100px"}>Precio unitario de platinado</Th>*/}
                              <Th className={vpreciounitario === false ? " displaynone" : "minwidth100px"}>Precio unitario Powder coat</Th>
                              <Th>Estatus</Th>
                              <Th>Usuario de registro </Th>
                              <Th>Fecha y hora de registro</Th>
                              <Th className="width30px" > Detalles </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {productos.map((producto, i) => (
                              <Tr class={(i % 2) !== 0 ? "table-active" : ""}>
                                <Td className="margintopmobil20px">{producto.numerodeParte}</Td>
                                <Td className="margintopmobil20px">{producto.numerodeParteSalida}</Td>
                                <Td className={producto.numerodeParteSalida ? "margintopmobil20px" : "margintopmobil40px"}>{producto.descripcion}</Td>
                                <Td className="margintopmobil20px">{producto.cantidadporAnio}</Td>
                                <Td className={vpreciounitario === false ? "margintopmobil20px displaynone" : "margintopmobil20px"}>
                                  {((producto.divisa === "Peso mexicano" || producto.divisa === "Dólar") ? "$" : "€") + " " + producto.precioUnitario}
                                </Td>
                                {/*<Td className={vpreciounitario === false ? "margintopmobil20px displaynone" : "margintopmobil20px"}>
                                  {producto.precioUnitarioP ? (((producto.divisa === "Peso mexicano" || producto.divisa === "Dólar") ? "$" : "€") + " " + producto.precioUnitarioP) : ""}
                                </Td>*/}
                                <Td className={vpreciounitario === false ? "margintopmobil20px displaynone" : "margintopmobil20px"}>
                                  {producto.precioUnitarioPC ? (((producto.divisa === "Peso mexicano" || producto.divisa === "Dólar") ? "$" : "€") + " " + producto.precioUnitarioPC) : ""}
                                </Td>
                                <Td className={producto.precioUnitarioP ? "margintopmobil20px" : "margintopmobil40px"}>{producto.activo ? "Activo" : "Inactivo"}</Td>
                                <Td className="margintopmobil20px">{producto.Reg_Ins_Usuario}</Td>
                                <Td className="margintopmobil20px">{Moment(producto.createdAt).format("DD/MM/YYYY, h:mm:ss a")}</Td>
                                <Td>
                                  <button class="btn-info cbutton mt-1 ml-1" onClick={() => onClickProducto(producto)} title="Detalles"> <IoIcons.IoMdList /> </button>
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </div>
                      {totalRecords > 0 && (
                        <>
                          <div className="mt-3 mb-3">
                            Página {currentPage}, mostrando del {(recordPerPage * currentPage - recordPerPage) + 1}  al {totalRecords < recordPerPage * currentPage ? totalRecords : recordPerPage * currentPage} de {totalRecords} registros
                          </div>
                          <Row>
                            <div className="col-lg-12 col-md-12 col-sm-12  " >
                              <div className="floatcenter">
                                <Pagination
                                  itemClass="page-item" // add it for bootstrap 4
                                  linkClass="page-link" // add it for bootstrap 4                                    
                                  activePage={currentPage}
                                  itemsCountPerPage={recordPerPage}
                                  totalItemsCount={totalRecords}
                                  pageRangeDisplayed={pageRange}
                                  onChange={handlePageChange}
                                />
                              </div>
                            </div>
                          </Row>
                        </>
                      )}
                    </>
                  )}
                  {mostrarproducto && (
                    <>
                      <div className="textaligmentleft">
                        <Row className="margintop20px ">
                          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <button class=" btn-primary cbutton " onClick={editarProducto} title="Editar"> <IoIcons.IoIosCreate />Editar </button>
                          </div>
                          <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                            <button class="btn-info cbutton floatrightleft" onClick={regresarCliente} title="Regresar"> <IoIcons.IoMdArrowRoundBack />Regresar </button>
                          </div>
                        </Row>
                        <Row className="margintop20px ">
                          <div className="col-lg-6 col-md-7 col-sm-12 col-xs-12">
                            <Table>
                              <Thead class="thead-secondary">
                                <Tr>
                                  <Th><h5>Característica</h5></Th>
                                  <Th ><h5>Valor</h5></Th>
                                </Tr>
                              </Thead>
                              <Tbody>

                                <Tr ><Td><h5>Número de parte:</h5></Td><Td> <h5>{formData.numerodeParte}</h5></Td></Tr>
                                {/*<Tr ><Td><h5>Seguimiento por número de parte:</h5></Td><Td> <h5>{formData.sporNP ? "Sí" : "NO"}</h5></Td></Tr>*/}
                                <Tr ><Td><h5>Número de parte para embarques:</h5></Td><Td> <h5>{formData.numerodeParteSalida}</h5></Td></Tr>
                                <Tr class="table-active"><Td className="minwidth300pxm"><h5>Descripción: </h5></Td><Td> <h5> {formData.descripcion}</h5> </Td></Tr>
                                <Tr ><Td><h5>PO para embarques:</h5></Td><Td> <h5>{formData.poEmbarques}</h5></Td></Tr>
                                {<Tr ><Td><h5>Precio unitario Ecoat: </h5></Td><Td> <h5> {formData.divisa === "Peso mexicano" || formData.divisa === "Dólar" ? "$" : "€"} {formData.precioUnitario} {formData.divisa === "Peso mexicano" ? " Pesos" : formData.divisa === "Dólar" ? "Dólares" : "Euros"} </h5> </Td></Tr>}
                                {/*<Tr ><Td><h5>Precio unitario de platinado : </h5></Td><Td> <h5> {formData.divisa === "Peso mexicano" || formData.divisa === "Dólar" ? "$" : "€"} {formData.precioUnitarioP} {formData.divisa === "Peso mexicano" ? " Pesos" : formData.divisa === "Dólar" ? "Dólares" : "Euros"} </h5> </Td></Tr>*/}
                                {<Tr ><Td><h5>Precio unitario Powder coat : </h5></Td><Td> <h5> {formData.divisa === "Peso mexicano" || formData.divisa === "Dólar" ? "$" : "€"} {formData.precioUnitarioPC} {formData.divisa === "Peso mexicano" ? " Pesos" : formData.divisa === "Dólar" ? "Dólares" : "Euros"} </h5> </Td></Tr>}
                                <Tr class="table-active"><Td><h5>Cantidad por año: </h5></Td><Td> <h5>  {formData.cantidadporAnio} pz </h5>  </Td></Tr>
                                <Tr class="table-active"><Td><h5>Piezas por Rack: </h5></Td><Td> <h5>  {formData.piezasXRack} pz </h5>  </Td></Tr>
                                <Tr class="table-active"><Td><h5>Tipo de Rack: </h5></Td><Td> <h5>  {formData.rackTipo}  </h5>  </Td></Tr>
                                <Tr ><Td><h5>Producto:  </h5></Td><Td> <h5>{formData.activo ? "Activo" : "Inactivo"}</h5>  </Td></Tr>
                                <Tr class="table-active"><Td><h5>Usuario de registro:  </h5></Td><Td> <h5> {formData.Reg_Ins_Usuario}</h5>   </Td></Tr>
                                <Tr ><Td><h5>Fecha de registro: </h5></Td><Td> <h5> {Moment(formData.createdAt).format("DD/MM/YYYY, h:mm:ss a")}</h5> </Td></Tr>
                                <Tr class="table-active"><Td><h5>Usuario de última actualización: </h5></Td><Td> <h5> {formData.Reg_Mod_Usuario}</h5></Td></Tr>
                                <Tr ><Td><h5>Fecha de última actualización: </h5></Td><Td> <h5> {formData.updatedAt !== formData.createdAt ? Moment(formData.updatedAt).format("DD/MM/YYYY, h:mm:ss a") : ""}</h5> </Td></Tr>
                                <Tr class="table-active"><Td><Label><h5>Archivo:</h5></Label> </Td><Td> <ol tipe="1" start="1" >
                                  {formData.documentodeEspecificaciones && (<li><a href={formData.documentodeEspecificacionesurl} >{formData.documentodeEspecificaciones + ' '}</a></li>)}
                                  {formData.documento1 && (<li><a href={formData.documento1url} >{formData.documento1 + ' '}</a></li>)}
                                  {formData.documento2 && (<li><a href={formData.documento2url} >{formData.documento2 + ' '}</a></li>)}
                                  {formData.documento3 && (<li><a href={formData.documento3url} >{formData.documento3 + ' '}</a></li>)}
                                  {formData.documento4 && (<li><a href={formData.documento4url} >{formData.documento4 + ' '}</a></li>)}
                                  {formData.documento5 && (<li><a href={formData.documento5url} >{formData.documento5 + ' '}</a></li>)}
                                  {formData.documento6 && (<li><a href={formData.documento6url} >{formData.documento6 + ' '}</a></li>)}
                                  {formData.documento7 && (<li><a href={formData.documento7url} >{formData.documento7 + ' '}</a></li>)}
                                  {formData.documento8 && (<li><a href={formData.documento8url} >{formData.documento8 + ' '}</a></li>)}
                                  {formData.documento9 && (<li><a href={formData.documento9url} >{formData.documento9 + ' '}</a></li>)}
                                </ol></Td></Tr>
                              </Tbody>
                            </Table>
                          </div>
                          <div className="col-lg-6 col-md-5 col-sm-12 col-xs-12 margintop20px ">
                            {/*<img src={formData.image} width= "300px"  /> */}
                            <Carousel
                              activeIndex={activeIndex}
                              next={next}
                              previous={previous}
                            >
                              <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
                              {slides}
                              <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
                              <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
                            </Carousel>
                          </div>
                        </Row>
                      </div>
                    </>
                  )}
                </Fragment>
              )
            }
            {//Nuevo producto
              formType === 'Nuevo Producto' && (
                <Fragment>
                  <Row >
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <Label className="floatleft" >Cliente* </Label>
                      {clienteName && (
                        <select name="clienteID" className="floatleft custom-select" onChange={onChanges} disabled >
                          <option className="" value={clienteID}>{clienteName}</option>
                        </select>)}
                      {!clienteName && (
                        <select name="clienteID" className="floatleft custom-select" onChange={onChanges} >
                          <option className="" value="">Elige un cliente</option>
                          {clientes.map(cliente => (
                            <>
                              {cliente.activo && (
                                <option className="" value={cliente.id}>{cliente.cliente}</option>
                              )}
                            </>
                          ))}
                        </select>
                      )}

                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">Número de parte*</Label>
                        <Input name="numerodeParte" maxLength={20} placeholder="Número de parte" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">Número de parte para embarques</Label>
                        <Input name="numerodeParteSalida" maxLength={20} placeholder="Número de parte para embarques" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">PO para embarques</Label>
                        <Input name="poEmbarques" maxLength={20} placeholder="PO para embarques" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className=" col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                      <Label className="floatleft">Proceso a aplicar* </Label>
                      <br />
                      <FormGroup >
                        <Label className="floatleft marginleft-130px margintop10px">
                          <input type="checkbox" name="Ecoat" onChange={onChangescheck} className='ml-2' />
                          Ecoat
                        </Label>
                        <Label className="floatleft  ml-2 margintop10px">
                          <input type="checkbox" name="Pcoat" onChange={onChangescheck} className='ml-2' />
                          Powder coat
                        </Label>
                        {/*<Label className="floatleft ml-2 margintop10px">
                          <input type="checkbox" name="Platinado" onChange={onChangescheck} className='ml-2' />
                          Platinado
                        </Label>*/}
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Descripción</Label>
                        <Input name="descripcion" maxLength={100} placeholder="Descripción" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                      <Label for="activo" className="floatleft" >Piezas por Rack </Label>
                      <Input name="piezasXRack" maxLength={20} onChange={onChanges} />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                      <Label for="activo" className="floatleft" >Activo* </Label>
                      <select name="activo" id="activo" className=" custom-select" onChange={onChanges}>
                        <option value="true">Sí</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                    {(formData.Ecoat ? formData.Ecoat : false) === true && (
                      <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Precio unitario Ecoat*</Label>
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <select name="divisa" className="" onChange={onChanges}>
                                  <option value="Dólar" title="Dólar">$</option>
                                  <option value="Euro" title="Euro">€</option>
                                  <option value="Peso mexicano" title="Peso mexicano">$</option>
                                </select>
                              </div>
                            </div>
                            <input type="text" name="precioUnitario" maxLength={10} value={formData.precioUnitario} class="form-control" aria-label="Text input with checkbox" onChange={onChanges} />
                          </div>
                        </FormGroup>
                      </div>
                    )}
                    {(formData.Pcoat ? formData.Pcoat : false) === true && (
                      <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Precio unitario Powder coat*</Label>
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <select name="divisa" className="" onChange={onChanges}>
                                  <option value="Dólar" title="Dólar">$</option>
                                  <option value="Euro" title="Euro">€</option>
                                  <option value="Peso mexicano" title="Peso mexicano">$</option>
                                </select>
                              </div>
                            </div>
                            <input type="text" name="precioUnitarioPC" maxLength={10} value={formData.precioUnitarioPC} class="form-control" aria-label="Text input with checkbox" onChange={onChanges} />
                          </div>
                        </FormGroup>
                      </div>
                    )}
                    {(formData.Platinado ? formData.Platinado : false) === true && (
                      <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Precio unitario Platinado*</Label>
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <select name="divisa" className="" onChange={onChanges}>
                                  <option value="Dólar" title="Dólar">$</option>
                                  <option value="Euro" title="Euro">€</option>
                                  <option value="Peso mexicano" title="Peso mexicano">$</option>
                                </select>
                              </div>
                            </div>
                            <input type="text" name="precioUnitarioP" maxLength={10} value={formData.precioUnitarioP} class="form-control" aria-label="Text input with checkbox" onChange={onChanges} />
                          </div>
                        </FormGroup>
                      </div>
                    )}
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Cantidad por año*</Label>
                        <div class="input-group mb-3">
                          <input type="text" name="cantidadporAnio" maxLength={10} value={formData.cantidadporAnio} class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon2" onChange={onChanges} />
                          <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2">pz</span>
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    {/*<div className="col-lg-2 col-md-2 col-sm-6 col-xs-12" >
                      <Label className="floatleft" >Seguimiento por número de parte</Label>
                      <div class="input-group mb-3">
                        <select name="sporNP" id="sporNP" className=" custom-select" onChange={onChanges}>
                          <option value="true">Sí</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                    </div>*/}
                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" >
                      <Label className="floatleft" >Tipo de Rack*</Label>
                      <div class="input-group mb-3">
                        <select name="rackTipo" id="rackTipo" className=" custom-select" onChange={onChanges}>
                          <option value=""></option>
                          <option value="Movible">Movible</option>
                          <option value="Fijo">Fijo</option>
                        </select>
                      </div>
                    </div>
                    {(clienteName === "CAS" || formData.clienteID === "66ef5748-ff06-436e-a566-6b9b0d2a8d9d") && (<>
                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <Label className="floatleft" >Cliente asociado</Label>
                        <select name="clienteAsociadoID" className="floatleft custom-select" onChange={onChanges} >
                          <option className="" value="">Elige un cliente</option>
                          {clientes.map(cliente => (
                            <>
                              {cliente.activo && (
                                <option className="" value={cliente.id}>{cliente.cliente}</option>
                              )}
                            </>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft ">Número de parte asociado</Label>
                          <Input name="numerodeParteAsociado" maxLength={20} placeholder="Número de parte asociado" onChange={onChanges} />
                        </FormGroup>
                      </div>
                    </>)}
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">Imagen del producto</Label>
                        <Input
                          name="image"
                          type="file"
                          onChange={onChangeimage}
                          accept=".gif,.jpg,.jpeg,.png,.jfif"
                        />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">Documento de especificaciones</Label>
                        <Input
                          name="documentodeEspecificaciones"
                          type="file"
                          onChange={onChangedocumento}
                        />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <button class="btn-info  mt-1 ml-1" onClick={() => setImagenn(imagenn + 1)} disabled={imagenn >= 10 ? true : false} title="Agregar imagen"> Agregar imagen  </button>
                    <button class="btn-warning  mt-1 ml-1" onClick={() => setDocumenton(documenton + 1)} disabled={documenton >= 10 ? true : false} title="Agregar documento"> Agregar documento </button>
                  </Row>
                  <Row>
                    {imagenn > 1 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup >
                          <Label className="floatleft ">Imagen del producto</Label>
                          <Input
                            name="image1"
                            type="file"
                            accept=".gif,.jpg,.jpeg,.png,.jfif"
                            onChange={onChangeimage}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {imagenn > 2 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup >
                          <Label className="floatleft ">Imagen del producto</Label>
                          <Input
                            name="image2"
                            type="file"
                            accept=".gif,.jpg,.jpeg,.png,.jfif"
                            onChange={onChangeimage}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {imagenn > 3 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup >
                          <Label className="floatleft ">Imagen del producto</Label>
                          <Input
                            name="image3"
                            type="file"
                            accept=".gif,.jpg,.jpeg,.png,.jfif"
                            onChange={onChangeimage}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {imagenn > 4 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup >
                          <Label className="floatleft ">Imagen del producto</Label>
                          <Input
                            name="image4"
                            type="file"
                            accept=".gif,.jpg,.jpeg,.png,.jfif"
                            onChange={onChangeimage}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {imagenn > 5 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup >
                          <Label className="floatleft ">Imagen del producto</Label>
                          <Input
                            name="image5"
                            type="file"
                            accept=".gif,.jpg,.jpeg,.png,.jfif"
                            onChange={onChangeimage}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {imagenn > 6 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup >
                          <Label className="floatleft ">Imagen del producto</Label>
                          <Input
                            name="image6"
                            type="file"
                            onChange={onChangeimage}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {imagenn > 7 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup >
                          <Label className="floatleft ">Imagen del producto</Label>
                          <Input
                            name="image7"
                            type="file"
                            accept=".gif,.jpg,.jpeg,.png,.jfif"
                            onChange={onChangeimage}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {imagenn > 8 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup >
                          <Label className="floatleft ">Imagen del producto</Label>
                          <Input
                            name="image8"
                            type="file"
                            accept=".gif,.jpg,.jpeg,.png,.jfif"
                            onChange={onChangeimage}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {imagenn > 9 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup >
                          <Label className="floatleft ">Imagen del producto</Label>
                          <Input
                            name="image9"
                            type="file"
                            accept=".gif,.jpg,.jpeg,.png,.jfif"
                            onChange={onChangeimage}
                          />
                        </FormGroup>
                      </div>
                    )
                    }

                    {documenton > 1 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">Documento del producto</Label>
                          <Input
                            name="documento1"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }

                    {documenton > 2 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">Documento del producto</Label>
                          <Input
                            name="documento2"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 3 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">Documento del producto</Label>
                          <Input
                            name="documento3"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 4 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">Documento del producto</Label>
                          <Input
                            name="documento4"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 5 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">Documento del producto</Label>
                          <Input
                            name="documento5"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 6 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">Documento del producto</Label>
                          <Input
                            name="documento6"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 7 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">Documento del producto</Label>
                          <Input
                            name="documento7"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 8 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">Documento del producto</Label>
                          <Input
                            name="documento8"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 9 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">Documento del producto</Label>
                          <Input
                            name="documento9"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                  </Row>
                  <Row> <div className="hr" />  <div className="hr" />    </Row>
                  <div>
                    <Button className="floatright" onClick={!clienteName ? catalogo : () => onClickCliente(clienteName, clienteID, clienteActivo)} color="danger" >
                      Cancelar
                    </Button>
                    <Button className="floatright" onClick={createProductos} disabled={isDisabled} color="primary" >
                      Guardar
                    </Button>
                  </div>
                  <div>{/*JSON.stringify(formData)*/}</div>
                </Fragment>
              )
            }
            {//Editar cliente
              formType === 'Editar Producto' && (
                <Fragment>
                  <Row >
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <Label className="floatleft" >Cliente* </Label>
                      <select name="clienteID" className="floatleft custom-select" onChange={onChanges} >
                        {/*<option  className="" value="">Elige un cliente</option>*/}
                        {clientes.map(cliente => (
                          <>
                            {cliente.activo && (
                              <option className="" value={cliente.id} selected={clienteName === cliente.cliente ? true : false}>{cliente.cliente}</option>
                            )}
                          </>
                        ))}
                      </select>

                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12" >
                      <FormGroup >
                        <Label className="floatleft ">Número de parte*</Label>
                        <Input name="numerodeParte" maxLength={20} value={formData.numerodeParte} placeholder="Número de parte" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12" >
                      <FormGroup >
                        <Label className="floatleft ">Número de parte para embarques</Label>
                        <Input name="numerodeParteSalida" maxLength={20} value={formData.numerodeParteSalida} placeholder="Número de parte para embarques" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className=" col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                      <Label className="floatleft">Proceso a aplicar* </Label>
                      <br />
                      <FormGroup >
                        <Label className="floatleft marginleft-130px margintop10px">
                          <input type="checkbox" name="Ecoat" onChange={onChangescheck} checked={formData.Ecoat ? formData.Ecoat : false} className='ml-2' />
                          Ecoat
                        </Label>
                        <Label className="floatleft  ml-2 margintop10px">
                          <input type="checkbox" name="Pcoat" onChange={onChangescheck} checked={formData.Pcoat ? formData.Pcoat : false} className='ml-2' />
                          Powder coat
                        </Label>
                        {/*<Label className="floatleft ml-2 margintop10px">
                          <input type="checkbox" name="Platinado" onChange={onChangescheck} checked={formData.Platinado ? formData.Platinado : false} className='ml-2' />
                          Platinado
                        </Label>*/}
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12" >
                      <FormGroup >
                        <Label className="floatleft ">PO para embarques</Label>
                        <Input name="poEmbarques" maxLength={20} value={formData.poEmbarques} placeholder="PO para embarques" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Descripción</Label>
                        <Input name="descripcion" maxLength={100} value={formData.descripcion} placeholder="Descripción" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                      <Label for="activo" className="floatleft" >Piezas por Rack </Label>
                      <Input name="piezasXRack" maxLength={20} value={formData.piezasXRack} onChange={onChanges} />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                      <Label for="activo" className="floatleft" >Activo* </Label>
                      <select name="activo" id="activo" className=" custom-select" onChange={onChanges}>
                        <option value="true" selected={formData.activo ? true : false}>Sí</option>
                        <option value="false" selected={!formData.activo ? true : false} >No</option>
                      </select>
                    </div>
                    {(formData.Ecoat ? formData.Ecoat : formData.precioUnitario ? true : false) === true && (
                      <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Precio unitario Ecoat*</Label>
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <select name="divisa" className="" onChange={onChanges}>
                                  <option value="Dólar" selected={formData.divisa === "Dólar" ? true : false} title="Dólar">$</option>
                                  <option value="Euro" selected={formData.divisa === "Euro" ? true : false} title="Euro">€</option>
                                  <option value="Peso mexicano" selected={formData.divisa === "Peso mexicano" ? true : false} title="Peso mexicano">$</option>
                                </select>
                              </div>
                            </div>
                            <input type="text" name="precioUnitario" maxLength={10} value={formData.precioUnitario} class="form-control" aria-label="Text input with checkbox" onChange={onChanges} />
                          </div>
                        </FormGroup>
                      </div>
                    )}
                    {(formData.Pcoat ? formData.Pcoat : false) === true && (
                      <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Precio unitario Powder coat*</Label>
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <select name="divisa" className="" onChange={onChanges}>
                                  <option value="Dólar" title="Dólar">$</option>
                                  <option value="Euro" title="Euro">€</option>
                                  <option value="Peso mexicano" title="Peso mexicano">$</option>
                                </select>
                              </div>
                            </div>
                            <input type="text" name="precioUnitarioPC" maxLength={10} value={formData.precioUnitarioPC} class="form-control" aria-label="Text input with checkbox" onChange={onChanges} />
                          </div>
                        </FormGroup>
                      </div>
                    )}
                    {(formData.Platinado ? formData.Platinado : false) === true && (
                      <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Precio unitario Platinado*</Label>
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <select name="divisa" className="" onChange={onChanges}>
                                  <option value="Dólar" title="Dólar">$</option>
                                  <option value="Euro" title="Euro">€</option>
                                  <option value="Peso mexicano" title="Peso mexicano">$</option>
                                </select>
                              </div>
                            </div>
                            <input type="text" name="precioUnitarioP" maxLength={10} value={formData.precioUnitarioP} class="form-control" aria-label="Text input with checkbox" onChange={onChanges} />
                          </div>
                        </FormGroup>
                      </div>
                    )}

                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" >
                      <FormGroup >
                        <Label className="floatleft" >Cantidad por año*</Label>
                        <div class="input-group mb-3">
                          <input type="text" name="cantidadporAnio" maxLength={10} value={formData.cantidadporAnio} class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon2" onChange={onChanges} />
                          <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2">pz</span>
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    {/*<div className="col-lg-3 col-md-3 col-sm-6 col-xs-12" >
                      <Label className="floatleft" >Seguimiento por número de parte</Label>
                      <div class="input-group mb-3">
                        <select name="sporNP" id="sporNP" className=" custom-select" onChange={onChanges}>
                          <option value="true" selected={formData.sporNP ? true : false}>Sí</option>
                          <option value="false" selected={!formData.sporNP ? true : false} >No</option>
                        </select>
                      </div>
                    </div>*/}
                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" >
                      <Label className="floatleft" >Tipo de Rack*</Label>
                      <div class="input-group mb-3">
                        <select name="rackTipo" id="rackTipo" className=" custom-select" onChange={onChanges}>
                          <option value="" selected={!formData.rackTipo ? true : false}></option>
                          <option value="Movible" selected={formData.rackTipo === "Movible" ? true : false}>Movible</option>
                          <option value="Fijo" selected={formData.rackTipo === "Fijo" ? true : false} >Fijo</option>
                        </select>
                      </div>
                    </div>
                    {clienteName === "CAS" && (<>
                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <Label className="floatleft" >Cliente asociado</Label>
                        <select name="clienteAsociadoID" className="floatleft custom-select" onChange={onChanges} >
                          <option className="" value="">Elige un cliente</option>
                          {clientes.map(cliente => (
                            <>
                              {cliente.activo && (
                                <option className="" value={cliente.id} selected={formData.clienteAsociadoID === cliente.id ? true : false} >{cliente.cliente}</option>
                              )}
                            </>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft ">Número de parte asociado</Label>
                          <Input name="numerodeParteAsociado" value={formData.numerodeParteAsociado} maxLength={20} placeholder="Número de parte asociado" onChange={onChanges} />
                        </FormGroup>
                      </div>
                    </>)}
                    {!formImages.image.name && (
                      <img src={formData.image} width="100px" title={formData.imagename} />)}
                    <div className={formImages.image.name ? "col-lg-4 col-md-6 col-sm-12 col-xs-12" : "col-lg-3 col-md-5 col-sm-12 col-xs-12"} >
                      <FormGroup >
                        <Label className="floatleft ">Imagen del producto</Label>
                        <Input
                          name="image"
                          type="file"
                          accept=".gif,.jpg,.jpeg,.png,.jfif"
                          onChange={onChangeimage}
                        />
                      </FormGroup>
                    </div>
                    <div className={formData.documentodeEspecificaciones ? editarArchivo ? "col-lg-4 col-md-6 col-sm-12 col-xs-12" : "col-lg-3 col-md-12 col-sm-12 col-xs-12" : "col-lg-4 col-md-12 col-sm-12 col-xs-12"} >
                      <FormGroup >
                        <Label className="floatleft "> {!formData.documentodeEspecificaciones ? "Documento de especificaciones" : <a href={formData.documentodeEspecificacionesurl} >{formData.documentodeEspecificaciones}</a>}</Label>
                        <Input
                          name="documentodeEspecificaciones"
                          type="file"
                          onChange={onChangedocumento}
                        />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <button class="btn-info  mt-1 ml-1" onClick={() => setImagenn(imagenn + 1)} disabled={imagenn >= 10 ? true : false} title="Agregar imagen"> Agregar imagen  </button>
                    <button class="btn-warning  mt-1 ml-1" onClick={() => setDocumenton(documenton + 1)} disabled={documenton >= 10 ? true : false} title="Agregar documento"> Agregar documento </button>
                  </Row>
                  <Row>
                    {imagenn > 1 && (
                      <>
                        {!formImages.image1.name && (
                          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <img src={formData.image1} width="100px" title={formData.imagename1} />
                          </div>)}
                        <div className={formImages.image1.name ? "col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" : "col-lg-4 col-md-4 col-sm-10 col-xs-10 margintop20px"}>
                          <FormGroup >
                            <Label className="floatleft ">Imagen del producto</Label>
                            <Input
                              name="image1"
                              type="file"
                              accept=".gif,.jpg,.jpeg,.png,.jfif"
                              onChange={onChangeimage}
                            />
                          </FormGroup>
                        </div>
                      </>
                    )
                    }
                    {imagenn > 2 && (
                      <>
                        {!formImages.image2.name && (
                          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <img src={formData.image2} width="100px" title={formData.imagename2} />
                          </div>)}
                        <div className={formImages.image1.name ? "col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" : "col-lg-4 col-md-4 col-sm-10 col-xs-10 margintop20px"}>
                          <FormGroup >
                            <Label className="floatleft ">Imagen del producto</Label>
                            <Input
                              name="image2"
                              type="file"
                              accept=".gif,.jpg,.jpeg,.png,.jfif"
                              onChange={onChangeimage}
                            />
                          </FormGroup>
                        </div>
                      </>
                    )
                    }
                    {imagenn > 3 && (
                      <>
                        {!formImages.image3.name && (
                          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <img src={formData.image3} width="100px" title={formData.imagename3} />
                          </div>)}
                        <div className={formImages.image3.name ? "col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" : "col-lg-4 col-md-4 col-sm-10 col-xs-10 margintop20px"}>
                          <FormGroup >
                            <Label className="floatleft ">Imagen del producto</Label>
                            <Input
                              name="image3"
                              type="file"
                              accept=".gif,.jpg,.jpeg,.png,.jfif"
                              onChange={onChangeimage}
                            />
                          </FormGroup>
                        </div>
                      </>
                    )
                    }
                    {imagenn > 4 && (
                      <>
                        {!formImages.image4.name && (
                          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <img src={formData.image4} width="100px" title={formData.imagename4} />
                          </div>)}
                        <div className={formImages.image4.name ? "col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" : "col-lg-4 col-md-4 col-sm-10 col-xs-10 margintop20px"}>
                          <FormGroup >
                            <Label className="floatleft ">Imagen del producto</Label>
                            <Input
                              name="image4"
                              type="file"
                              accept=".gif,.jpg,.jpeg,.png,.jfif"
                              onChange={onChangeimage}
                            />
                          </FormGroup>
                        </div>
                      </>
                    )
                    }
                    {imagenn > 5 && (
                      <>
                        {!formImages.image5.name && (
                          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <img src={formData.image5} width="100px" title={formData.imagename5} />
                          </div>)}
                        <div className={formImages.image5.name ? "col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" : "col-lg-4 col-md-4 col-sm-10 col-xs-10 margintop20px"}>
                          <FormGroup >
                            <Label className="floatleft ">Imagen del producto</Label>
                            <Input
                              name="image5"
                              type="file"
                              accept=".gif,.jpg,.jpeg,.png,.jfif"
                              onChange={onChangeimage}
                            />
                          </FormGroup>
                        </div>
                      </>
                    )
                    }
                    {imagenn > 6 && (
                      <>
                        {!formImages.image6.name && (
                          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <img src={formData.image6} width="100px" title={formData.imagename6} />
                          </div>)}
                        <div className={formImages.image6.name ? "col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" : "col-lg-4 col-md-4 col-sm-10 col-xs-10 margintop20px"}>
                          <FormGroup >
                            <Label className="floatleft ">Imagen del producto</Label>
                            <Input
                              name="image6"
                              type="file"
                              accept=".gif,.jpg,.jpeg,.png,.jfif"
                              onChange={onChangeimage}
                            />
                          </FormGroup>
                        </div>
                      </>
                    )
                    }
                    {imagenn > 7 && (
                      <>
                        {!formImages.image7.name && (
                          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <img src={formData.image7} width="100px" title={formData.imagename7} />
                          </div>)}
                        <div className={formImages.image7.name ? "col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" : "col-lg-4 col-md-4 col-sm-10 col-xs-10 margintop20px"}>
                          <FormGroup >
                            <Label className="floatleft ">Imagen del producto</Label>
                            <Input
                              name="image7"
                              type="file"
                              accept=".gif,.jpg,.jpeg,.png,.jfif"
                              onChange={onChangeimage}
                            />
                          </FormGroup>
                        </div>
                      </>
                    )
                    }
                    {imagenn > 8 && (
                      <>
                        {!formImages.image8.name && (
                          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <img src={formData.image8} width="100px" title={formData.imagename8} />
                          </div>)}
                        <div className={formImages.image8.name ? "col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" : "col-lg-4 col-md-4 col-sm-10 col-xs-10 margintop20px"}>
                          <FormGroup >
                            <Label className="floatleft ">Imagen del producto</Label>
                            <Input
                              name="image8"
                              type="file"
                              accept=".gif,.jpg,.jpeg,.png,.jfif"
                              onChange={onChangeimage}
                            />
                          </FormGroup>
                        </div>
                      </>
                    )
                    }
                    {imagenn > 9 && (
                      <>
                        {!formImages.image9.name && (
                          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <img src={formData.image9} width="100px" title={formData.imagename9} />
                          </div>)}
                        <div className={formImages.image9.name ? "col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" : "col-lg-4 col-md-4 col-sm-10 col-xs-10 margintop20px"}>
                          <FormGroup >
                            <Label className="floatleft ">Imagen del producto</Label>
                            <Input
                              name="image9"
                              type="file"
                              accept=".gif,.jpg,.jpeg,.png,.jfif"
                              onChange={onChangeimage}
                            />
                          </FormGroup>
                        </div>
                      </>
                    )
                    }

                    {documenton > 1 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">{!formData.documento1 ? "Documento de especificaciones" : <a href={formData.documento1} >{formData.documento1}</a>}</Label>
                          <Input
                            name="documento1"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }

                    {documenton > 2 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">{!formData.documento2 ? "Documento de especificaciones" : <a href={formData.documento2} >{formData.documento2}</a>}</Label>
                          <Input
                            name="documento2"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 3 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">{!formData.documento3 ? "Documento de especificaciones" : <a href={formData.documento3} >{formData.documento3}</a>}</Label>
                          <Input
                            name="documento3"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 4 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">{!formData.documento4 ? "Documento de especificaciones" : <a href={formData.documento4} >{formData.documento4}</a>}</Label>
                          <Input
                            name="documento4"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 5 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">{!formData.documento5 ? "Documento de especificaciones" : <a href={formData.documento5} >{formData.documento5}</a>}</Label>
                          <Input
                            name="documento5"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 6 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">{!formData.documento6 ? "Documento de especificaciones" : <a href={formData.documento6} >{formData.documento6}</a>}</Label>
                          <Input
                            name="documento6"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 7 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">{!formData.documento7 ? "Documento de especificaciones" : <a href={formData.documento7} >{formData.documento7}</a>}</Label>
                          <Input
                            name="documento7"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 8 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">{!formData.documento8 ? "Documento de especificaciones" : <a href={formData.documento8} >{formData.documento8}</a>}</Label>
                          <Input
                            name="documento8"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                    {documenton > 9 && (
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                        <FormGroup >
                          <Label className="floatleft ">{!formData.documento9 ? "Documento de especificaciones" : <a href={formData.documento9} >{formData.documento9}</a>}</Label>
                          <Input
                            name="documento9"
                            type="file"
                            onChange={onChangedocumento}
                          />
                        </FormGroup>
                      </div>
                    )
                    }
                  </Row>
                  <Row> <div className="hr" />  <div className="hr" />    </Row>
                  <div>
                    <Button className="floatright" onClick={!clienteName ? catalogo : () => onClickCliente(clienteName, clienteID, clienteActivo)} color="danger" >
                      Cancelar
                    </Button>
                    <Button className="floatright" onClick={updateProductos} disabled={isDisabled} color="primary" >
                      Guardar
                    </Button>
                  </div>
                </Fragment>

              )}

          </div>
        </>
      )
      }
    </>
  )
}

export default Productos
